<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="popBox" v-show="show">
			<div class="inner">
				<img src="../../assets/error.png" >
				<h3>读卡异常 请重新尝试<br>或者返回选择其他读取方式</h3>
				<div class="fcc">
					<div class="button-blue" @click="show=false">
						确定
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-pop-book-ok',
		// props: {
		// 	msg: String
		// },
		data() {
			return {
				//timer:null,
				show:true
			}
		},
	
		
		mounted() {
			
		},
		methods: {
			
		},
		beforeDestroy() {
			//clearTimeout(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
		.inner{
			padding-top:81px;
			text-align: center;
			img{
				height: 306px;
				margin-bottom: 42px;
			}
			h3{
				font-size: 38px;
				
				font-weight: 800;
				color: #333333;
				line-height: 58px;
				margin-bottom: 183px;
			}
		}
</style>
